import i18n from '../i18n';

export function getMaterialEnglishName(material) {
  return (material?.name || material?.material_name || '').trim();
}

export function getMaterialDutchName(material) {
  return (material?.name_nl || material?.material_name_nl || '').trim();
}

export function getMaterialNameForLocale(material, locale = i18n.resolvedLanguage || i18n.language || 'en') {
  const englishName = getMaterialEnglishName(material);
  const dutchName = getMaterialDutchName(material);

  if (locale === 'nl' && dutchName) {
    return dutchName;
  }

  return englishName;
}

export function getMaterialName(material) {
  return getMaterialNameForLocale(material);
}
